import { Button } from '@cian/ui-kit';
import * as styles from './style.css';

interface IGenplanControlsProps {
  isFloorPlanAvailable: boolean;
  onFloorPlanClick(): void;
}

export const GenplanControls = ({ isFloorPlanAvailable, onFloorPlanClick }: IGenplanControlsProps) => {
  if (!isFloorPlanAvailable) {
    return null;
  }

  return (
    <div className={styles['controls']}>
      {isFloorPlanAvailable && (
        <Button theme="fill_white_primary" onClick={onFloorPlanClick}>
          Квартиры на этажах
        </Button>
      )}
    </div>
  );
};
